import Confetti from 'react-confetti';
import {
  Box,
  Button,
  IconCheckCircle,
  IconHighlightOff,
  LoadingSpinner,
} from '@capitalise/ui-design-system';
import { useCreditLimitContext } from '../../../hooks/useCreditLimitContext';
import { useMemo } from 'react';

const Confirmation = () => {
  const { error, maxMonitorClients, selectedClientsAmount, onClose, paymentLoading } =
    useCreditLimitContext();

  const confirmationTitle = useMemo(
    () => (error ? 'Payment unsuccessful' : 'Payment successful!'),
    [error],
  );
  const confirmationSubtitle = useMemo(
    () =>
      error
        ? 'Sorry, we have a technical error, please try again later.'
        : `${
            selectedClientsAmount - maxMonitorClients
          } new clients added to your plan. Now you can monitor up to ${selectedClientsAmount} clients.`,
    [error, maxMonitorClients, selectedClientsAmount],
  );
  const successContent = (
    <>
      <Confetti
        width={160}
        height={160}
        confettiSource={{ x: 80, y: 80 }}
        tweenDuration={1500}
        recycle={false}
      />
      <IconCheckCircle width={80} height={80} color="green" />
    </>
  );

  const errorContent = <IconHighlightOff width={80} height={80} color="danger" />;

  const loadingContent = <LoadingSpinner size="3xlarge" />;

  const getConfirmationContent = () => {
    if (paymentLoading) {
      return loadingContent;
    }
    return error ? errorContent : successContent;
  };

  const alignVerticallyStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    '-webkit-transform': 'translate(-50%, -50%)',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <Box>
      <Box display="flex" flexDirection="column" alignItems="center" style={alignVerticallyStyles}>
        <Box
          width={160}
          height={160}
          position="relative"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {getConfirmationContent()}
        </Box>
        <Box typography="heading-28" width="417px" textAlign="center">
          {!paymentLoading ? confirmationTitle : null}
        </Box>
        <Box typography="body-16" mt="3xsmall" textAlighn="center" width="417px" textAlign="center">
          {!paymentLoading ? confirmationSubtitle : null}
        </Box>
      </Box>
      {!error && (
        <Box position="absolute" bottom="3xsmall" left="xlarge" right="xlarge">
          <Button baseColor="green" fullWidth onClick={onClose} loading={paymentLoading}>
            Return to managing clients
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Confirmation;
